<template>
  <layout-basic>
    <v-container grid-list-md text-xs-center fluid>
      <v-layout row wrap>
        <v-flex xs8>
          <v-card flat>
            <v-card-text class="px-0">
              <info-widget></info-widget>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs2>
          <v-card flat>
            <v-card-text class="px-0">
              <tour-widget></tour-widget>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs2>
          <v-card flat>
            <v-card-text class="px-0">
              <buy-now-widget></buy-now-widget>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card flat>
            <v-card-text class="px-0">
              <setting-up-widget></setting-up-widget>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </layout-basic>
</template>
<script>
import LayoutBasic from "@/layouts/Dashboard";
import BuyNowWidget from "@/components/authenticated/welcome/Buynowwidget";
import InfoWidget from "@/components/authenticated/welcome/Infowidget";
import SettingUpWidget from "@/components/authenticated/welcome/Settingupwidget";
import TourWidget from "@/components/authenticated/welcome/Tourwidget";

export default {
  name: "Welcome",
  components: {
    LayoutBasic,
    BuyNowWidget,
    InfoWidget,
    SettingUpWidget,
    TourWidget
  }
};
</script>
